import { ArrowRightIcon } from '@heroicons/react/outline';
import { SiInstagram } from 'react-icons/si';

const Instagram = () => {
  return (
    <div
      className={`sm:rounded-tr-lg relative group bg-white p-6 focus-within:ring-2 focus-within:ring-inset focus-within:ring-sky-500 hover:bg-gray-50`}
    >
      <div>
        <span
          className={`bg-purple-50 text-purple-600 rounded-lg inline-flex p-3 ring-4 ring-white`}
        >
          <SiInstagram className="h-6 w-6" aria-hidden="true" />
        </span>
      </div>
      <div className="mt-5">
        <h3 className="text-lg font-medium">
          <a href="#" className="focus:outline-none">
            {/* Extend touch target to entire panel */}
            <span className="absolute inset-0" aria-hidden="true" />
            Instagram
          </a>
        </h3>
        <p className="mt-2 text-sm text-gray-500">
          Connect to your Instagram account to easily create posts.
        </p>
      </div>
      <span
        className="flex items-center space-x-2 pointer-events-none absolute top-6 right-6 text-gray-300 group-hover:text-gray-400"
        aria-hidden="true"
      >
        <span className="text-xs">Connect</span>
        <ArrowRightIcon className="h-8 w-8 stroke-0 transform -rotate-45" />
      </span>
    </div>
  );
};

export default Instagram;
